import { gql, useMutation } from '@apollo/client';
import { LoadingButton } from '@mui/lab';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import TextField from 'components/Inputs/TextField';
import { useUser } from 'contexts/userContext';
import { GetPromotionByUserResponse } from 'graphql/query/qna';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from 'types';

const USER_PROMOTION_ANSWER = gql`
  mutation UserPromotionAnswer($inputs: [UserQAInput]) {
    userPromotionAnswer(inputs: $inputs) {
      _id
      desc
    }
  }
`;
type UserPromotionAnswerRespone = {
  userPromotionAnswer: {
    _id: string;
    desc: string;
  };
};
type UserPromotionAnswerVariables = {
  inputs: {
    _id?: string;
    desc: string;
    qa?: string;
    userId?: string;
  }[];
};

const QnAForm: React.FC<{
  initialQnAs: GetPromotionByUserResponse['getPromotionByUser'];
  employee: User;
}> = ({ initialQnAs, employee }) => {
  const [formState, setFormState] = useState(
    initialQnAs.map((currAns, idx) => {
      return {
        _id: currAns.answer?._id ?? idx,
        desc: currAns.answer?.desc ?? '',
        qa: currAns.question._id,
        userId: employee._id,
      };
    })
  );
  const { user: loggedInUser } = useUser();
  const isThemself = loggedInUser?._id === employee._id;
  const navigate = useNavigate();
  const [updatePromotionAnswer, { loading: updatingPromotionAnswer }] = useMutation<
    UserPromotionAnswerRespone,
    UserPromotionAnswerVariables
  >(USER_PROMOTION_ANSWER);

  const data = formState.reduce((acc, curr) => {
    const ansKey = curr._id;
    acc[ansKey] = curr.desc;

    return acc;
  }, {});

  const isMobileScreen = useMediaQuery('(max-width:600px)');

  const handleChange = (ansKey: any, value: string) => {
    const newFormstate = formState.map(curr => {
      if (curr._id === ansKey) {
        return {
          ...curr,
          desc: value,
        };
      } else {
        return curr;
      }
    });
    setFormState(newFormstate);
  };

  const handleSubmit = () => {
    const refinedData = formState.map(o => {
      if (typeof o._id === 'number') {
        return {
          ...o,
          _id: undefined,
        };
      } else {
        return o;
      }
    });
    updatePromotionAnswer({
      variables: {
        inputs: refinedData,
      },
      onCompleted: () => navigate(-1),
    });
  };

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <Grid container direction={'column'} rowGap={2} xs={12} md={10}>
        {initialQnAs.map((currQnA, idx) => {
          return (
            <Grid item container direction={'column'}>
              <Grid item display={'flex'} columnGap={1}>
                <Typography variant="subtitle1">Q:</Typography>
                <Typography variant="subtitle1">{currQnA.question.desc}</Typography>
              </Grid>
              <Grid item display={'flex'} columnGap={1}>
                <Typography variant="subtitle1">A:</Typography>
                <TextField
                  disabled={isThemself}
                  sx={{ width: isMobileScreen ? '100%' : '100%' }}
                  multiline
                  minRows={2}
                  value={data[currQnA.answer?._id ?? idx]}
                  onChange={e => handleChange(currQnA.answer?._id ?? idx, e.target.value)}
                />
              </Grid>
            </Grid>
          );
        })}
        <Grid item display={'flex'} justifyContent={'flex-end'}>
          <LoadingButton
            variant="contained"
            disabled={isThemself}
            type="submit"
            loading={updatingPromotionAnswer}
          >
            Submit
          </LoadingButton>
        </Grid>
      </Grid>
    </form>
  );
};

export default QnAForm;
